import { render } from "./AuthCard.html?vue&type=template&id=23cfc34c&scoped=true&ts=true&external"
import script from "./AuthCard.vue?vue&type=script&lang=ts"
export * from "./AuthCard.vue?vue&type=script&lang=ts"

import "./AuthCard.scss?vue&type=style&index=0&id=23cfc34c&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cfc34c"]])

export default __exports__